/** 发票中心接口：订单列表、发票列表、开票资格、申请开票 */
import request from '@/utils/request';

const INVOICE_API = '/api/user/api/invoice';
const PAYMENT_API = '/api/user/api/payment';

function indivGet(url, params = {}) {
  return request.get(url, { params }).catch(() => null);
}

function indivPost(url, params = {}) {
  return request.post(url, null, { params });
}

export function fetchOrderList() {
  return indivGet(`${PAYMENT_API}/order/list`, { size: 1000 }).then((data) => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.list)) return data.list;
    return [];
  });
}

export function fetchInvoiceList() {
  return indivGet(`${INVOICE_API}/list`).then((data) => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.list)) return data.list;
    return [];
  });
}

export function checkInvoiceEligible(orderId) {
  return indivGet(`${INVOICE_API}/check_eligible`, { orderId });
}

export function applyInvoice(payload = {}) {
  return indivPost(`${INVOICE_API}/apply`, payload);
}

export function requestInvoiceCancel(invoiceId) {
  return indivPost(`${INVOICE_API}/request_cancel`, { invoiceId });
}

function fileNameFromUrl(url, fallback = 'invoice.pdf') {
  const part = String(url || '').split('?')[0].split('/').pop();
  return part || fallback;
}

async function fetchFileBlob(fileUrl) {
  const url = String(fileUrl || '').trim();
  if (!url) {
    throw new Error('文件地址无效');
  }

  if (/^https?:\/\//i.test(url)) {
    const res = await fetch(url);
    if (!res.ok) throw new Error('下载失败');
    return res.blob();
  }

  const res = await request.get(url, {
    responseType: 'blob',
    rawResponse: true,
    baseURL: '',
  });
  return res.data;
}

/** 拉取文件并触发浏览器下载（避免 PDF 直接在浏览器打开） */
export async function downloadInvoiceFile(fileUrl, filename) {
  const blob = await fetchFileBlob(fileUrl);

  if (blob && blob.type === 'application/json') {
    const text = await blob.text();
    try {
      const json = JSON.parse(text);
      throw new Error(json.message || json.msg || '下载失败');
    } catch (err) {
      if (err instanceof SyntaxError) throw new Error('下载失败');
      throw err;
    }
  }

  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = blobUrl;
  link.download = filename || fileNameFromUrl(fileUrl);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
}

export { fileNameFromUrl as invoiceFileNameFromUrl };



// WEBPACK FOOTER //
// ./src/view/client/personal-center/panels/InvoiceCenter/api.js